import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "service-performance-root" }
const _hoisted_2 = {
  class: "service-performance-shell shipment-modal-shell",
  role: "dialog",
  "aria-modal": "true",
  "aria-labelledby": "servicePerformanceTitle"
}
const _hoisted_3 = { class: "service-performance-header shipment-modal-header" }
const _hoisted_4 = { class: "service-performance-header-actions" }
const _hoisted_5 = {
  class: "service-performance-range-selector shipment-modal-segmented-control",
  role: "group",
  "aria-label": "Performance range"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "service-performance-body shipment-modal-body" }
const _hoisted_8 = {
  key: 0,
  class: "service-performance-error shipment-modal-empty-state"
}
const _hoisted_9 = {
  key: 1,
  class: "service-performance-loading shipment-modal-empty-state"
}
const _hoisted_10 = { class: "service-performance-summary-grid" }
const _hoisted_11 = { class: "summary-card shipment-modal-card" }
const _hoisted_12 = { class: "summary-value-row" }
const _hoisted_13 = { class: "summary-caption" }
const _hoisted_14 = { class: "summary-card shipment-modal-card" }
const _hoisted_15 = { class: "summary-value-row" }
const _hoisted_16 = { class: "summary-value" }
const _hoisted_17 = { class: "summary-caption" }
const _hoisted_18 = { class: "summary-card shipment-modal-card" }
const _hoisted_19 = { class: "summary-value-row" }
const _hoisted_20 = { class: "summary-value" }
const _hoisted_21 = { class: "summary-caption" }
const _hoisted_22 = { class: "summary-card shipment-modal-card" }
const _hoisted_23 = { class: "summary-value-row" }
const _hoisted_24 = { class: "summary-value summary-value-small" }
const _hoisted_25 = { class: "summary-caption" }
const _hoisted_26 = { class: "service-performance-chart-grid" }
const _hoisted_27 = { class: "chart-card shipment-modal-card" }
const _hoisted_28 = {
  key: 0,
  class: "chart-surface"
}
const _hoisted_29 = {
  viewBox: "0 0 520 220",
  preserveAspectRatio: "none",
  class: "trend-chart"
}
const _hoisted_30 = ["x1", "y1", "x2", "y2"]
const _hoisted_31 = ["x", "y"]
const _hoisted_32 = ["d"]
const _hoisted_33 = ["d"]
const _hoisted_34 = ["d"]
const _hoisted_35 = ["cx", "cy"]
const _hoisted_36 = ["cx", "cy"]
const _hoisted_37 = { class: "chart-axis-labels" }
const _hoisted_38 = {
  key: 1,
  class: "chart-empty shipment-modal-empty-state"
}
const _hoisted_39 = { class: "chart-card shipment-modal-card" }
const _hoisted_40 = { class: "chart-card-header shipment-modal-card-header" }
const _hoisted_41 = { class: "chart-stat-pill shipment-modal-pill" }
const _hoisted_42 = {
  key: 0,
  class: "chart-surface"
}
const _hoisted_43 = {
  viewBox: "0 0 520 220",
  preserveAspectRatio: "none",
  class: "trend-chart"
}
const _hoisted_44 = ["x1", "y1", "x2", "y2"]
const _hoisted_45 = ["x", "y"]
const _hoisted_46 = ["d"]
const _hoisted_47 = ["d"]
const _hoisted_48 = ["cx", "cy"]
const _hoisted_49 = { class: "chart-axis-labels" }
const _hoisted_50 = {
  key: 1,
  class: "chart-empty shipment-modal-empty-state"
}
const _hoisted_51 = { class: "service-performance-meta-grid" }
const _hoisted_52 = {
  key: 0,
  class: "meta-card shipment-modal-card"
}
const _hoisted_53 = { class: "courier-performance-grid" }
const _hoisted_54 = { class: "courier-card-header" }
const _hoisted_55 = { class: "courier-card-meta" }
const _hoisted_56 = {
  key: 1,
  class: "meta-card shipment-modal-card"
}
const _hoisted_57 = { class: "common-error-list" }
const _hoisted_58 = { class: "common-error-rate" }
const _hoisted_59 = { class: "meta-card recent-errors-card shipment-modal-card" }
const _hoisted_60 = {
  key: 0,
  class: "recent-errors-table-wrapper"
}
const _hoisted_61 = { class: "recent-errors-table" }
const _hoisted_62 = { class: "courier-pill" }
const _hoisted_63 = { class: "tracking-cell" }
const _hoisted_64 = {
  key: 1,
  class: "chart-empty shipment-modal-empty-state"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      ref: "triggerRef",
      type: "button",
      class: "button pill -text service-performance-trigger",
      "aria-label": "Service Performance",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openModal && _ctx.openModal(...args)))
    }, [...(_cache[3] || (_cache[3] = [
      _createElementVNode("span", { class: "icon-performance-21 icon-grey" }, null, -1 /* CACHED */)
    ]))], 512 /* NEED_PATCH */),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.isOpen)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "service-performance-modal shipment-modal-overlay",
            onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)), ["self"]))
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _cache[5] || (_cache[5] = _createElementVNode("div", { class: "shipment-modal-title-block" }, [
                  _createElementVNode("p", { class: "service-performance-eyebrow shipment-modal-eyebrow" }, "Tracking Health"),
                  _createElementVNode("h3", {
                    id: "servicePerformanceTitle",
                    class: "shipment-modal-title"
                  }, "Service performance"),
                  _createElementVNode("p", { class: "service-performance-subtitle shipment-modal-subtitle" }, " Shipment tracking execution trends, success rate, and recent failures. ")
                ], -1 /* CACHED */)),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rangeOptions, (option) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: option.value,
                        type: "button",
                        class: _normalizeClass(['range-chip', 'shipment-modal-segment-chip', { active: _ctx.selectedRangeDays === option.value }]),
                        onClick: ($event: any) => (_ctx.selectedRangeDays = option.value)
                      }, _toDisplayString(option.label), 11 /* TEXT, CLASS, PROPS */, _hoisted_6))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "button pill -text service-performance-close shipment-modal-close",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
                    "aria-label": "Close"
                  }, [...(_cache[4] || (_cache[4] = [
                    _createElementVNode("i", { class: "material-icons" }, "close", -1 /* CACHED */)
                  ]))])
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                (_ctx.errorMessage)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.errorMessage), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                (_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [...(_cache[6] || (_cache[6] = [
                      _createElementVNode("div", { class: "loading-spinner" }, null, -1 /* CACHED */),
                      _createElementVNode("span", null, "Loading service metrics…", -1 /* CACHED */)
                    ]))]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _cache[7] || (_cache[7] = _createElementVNode("span", { class: "summary-label" }, "System status", -1 /* CACHED */)),
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("span", {
                              class: _normalizeClass(['health-badge', _ctx.healthStatusClass])
                            }, _toDisplayString(_ctx.healthStatusLabel), 3 /* TEXT, CLASS */)
                          ]),
                          _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.healthStatusCaption), 1 /* TEXT */)
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                          _cache[8] || (_cache[8] = _createElementVNode("span", { class: "summary-label" }, "Success rate", -1 /* CACHED */)),
                          _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.formatPercent(_ctx.averageSuccessRate)), 1 /* TEXT */)
                          ]),
                          _createElementVNode("p", _hoisted_17, "Across " + _toDisplayString(_ctx.trends.length) + " day" + _toDisplayString(_ctx.trends.length === 1 ? '' : 's'), 1 /* TEXT */)
                        ]),
                        _createElementVNode("div", _hoisted_18, [
                          _cache[9] || (_cache[9] = _createElementVNode("span", { class: "summary-label" }, "Avg execution", -1 /* CACHED */)),
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.formatDuration(_ctx.averageExecutionTime)), 1 /* TEXT */)
                          ]),
                          _createElementVNode("p", _hoisted_21, "From " + _toDisplayString(_ctx.totalExecutions) + " execution" + _toDisplayString(_ctx.totalExecutions === 1 ? '' : 's'), 1 /* TEXT */)
                        ]),
                        _createElementVNode("div", _hoisted_22, [
                          _cache[10] || (_cache[10] = _createElementVNode("span", { class: "summary-label" }, "Last run", -1 /* CACHED */)),
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.lastExecutionLabel), 1 /* TEXT */)
                          ]),
                          _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.lastExecutionCaption), 1 /* TEXT */)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("section", _hoisted_27, [
                          _cache[11] || (_cache[11] = _createElementVNode("div", { class: "chart-card-header shipment-modal-card-header" }, [
                            _createElementVNode("div", null, [
                              _createElementVNode("h4", null, "Success vs errors"),
                              _createElementVNode("p", null, "Daily success rate compared to failure rate.")
                            ]),
                            _createElementVNode("div", { class: "chart-legend" }, [
                              _createElementVNode("span", null, [
                                _createElementVNode("i", { class: "legend-dot success" }),
                                _createTextVNode("Success")
                              ]),
                              _createElementVNode("span", null, [
                                _createElementVNode("i", { class: "legend-dot error" }),
                                _createTextVNode("Error")
                              ])
                            ])
                          ], -1 /* CACHED */)),
                          (_ctx.rateChart.points.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                (_openBlock(), _createElementBlock("svg", _hoisted_29, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rateChart.gridLines, (line) => {
                                    return (_openBlock(), _createElementBlock("g", {
                                      key: `rate-grid-${line.value}`
                                    }, [
                                      _createElementVNode("line", {
                                        x1: line.x1,
                                        y1: line.y,
                                        x2: line.x2,
                                        y2: line.y,
                                        class: "grid-line"
                                      }, null, 8 /* PROPS */, _hoisted_30),
                                      _createElementVNode("text", {
                                        x: line.labelX,
                                        y: line.labelY,
                                        class: "grid-label"
                                      }, _toDisplayString(line.label), 9 /* TEXT, PROPS */, _hoisted_31)
                                    ]))
                                  }), 128 /* KEYED_FRAGMENT */)),
                                  _createElementVNode("path", {
                                    d: _ctx.rateChart.areaPath,
                                    class: "success-area"
                                  }, null, 8 /* PROPS */, _hoisted_32),
                                  _createElementVNode("path", {
                                    d: _ctx.rateChart.successPath,
                                    class: "success-line"
                                  }, null, 8 /* PROPS */, _hoisted_33),
                                  _createElementVNode("path", {
                                    d: _ctx.rateChart.errorPath,
                                    class: "error-line"
                                  }, null, 8 /* PROPS */, _hoisted_34),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rateChart.successPoints, (point) => {
                                    return (_openBlock(), _createElementBlock("circle", {
                                      key: `success-${point.index}`,
                                      cx: point.x,
                                      cy: point.y,
                                      r: "4",
                                      class: "success-point"
                                    }, null, 8 /* PROPS */, _hoisted_35))
                                  }), 128 /* KEYED_FRAGMENT */)),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rateChart.errorPoints, (point) => {
                                    return (_openBlock(), _createElementBlock("circle", {
                                      key: `error-${point.index}`,
                                      cx: point.x,
                                      cy: point.y,
                                      r: "4",
                                      class: "error-point"
                                    }, null, 8 /* PROPS */, _hoisted_36))
                                  }), 128 /* KEYED_FRAGMENT */))
                                ])),
                                _createElementVNode("div", _hoisted_37, [
                                  _createElementVNode("span", null, _toDisplayString(_ctx.rateChart.firstLabel), 1 /* TEXT */),
                                  _createElementVNode("span", null, _toDisplayString(_ctx.rateChart.middleLabel), 1 /* TEXT */),
                                  _createElementVNode("span", null, _toDisplayString(_ctx.rateChart.lastLabel), 1 /* TEXT */)
                                ])
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_38, "No performance trend data is available yet. "))
                        ]),
                        _createElementVNode("section", _hoisted_39, [
                          _createElementVNode("div", _hoisted_40, [
                            _cache[12] || (_cache[12] = _createElementVNode("div", null, [
                              _createElementVNode("h4", null, "Execution time"),
                              _createElementVNode("p", null, "Average duration for each scheduled tracking run.")
                            ], -1 /* CACHED */)),
                            _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.formatDuration(_ctx.averageExecutionTime)) + " avg ", 1 /* TEXT */)
                          ]),
                          (_ctx.latencyChart.points.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                (_openBlock(), _createElementBlock("svg", _hoisted_43, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.latencyChart.gridLines, (line) => {
                                    return (_openBlock(), _createElementBlock("g", {
                                      key: `latency-grid-${line.value}`
                                    }, [
                                      _createElementVNode("line", {
                                        x1: line.x1,
                                        y1: line.y,
                                        x2: line.x2,
                                        y2: line.y,
                                        class: "grid-line"
                                      }, null, 8 /* PROPS */, _hoisted_44),
                                      _createElementVNode("text", {
                                        x: line.labelX,
                                        y: line.labelY,
                                        class: "grid-label"
                                      }, _toDisplayString(line.label), 9 /* TEXT, PROPS */, _hoisted_45)
                                    ]))
                                  }), 128 /* KEYED_FRAGMENT */)),
                                  _createElementVNode("path", {
                                    d: _ctx.latencyChart.areaPath,
                                    class: "latency-area"
                                  }, null, 8 /* PROPS */, _hoisted_46),
                                  _createElementVNode("path", {
                                    d: _ctx.latencyChart.path,
                                    class: "latency-line"
                                  }, null, 8 /* PROPS */, _hoisted_47),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.latencyChart.points, (point) => {
                                    return (_openBlock(), _createElementBlock("circle", {
                                      key: `latency-${point.index}`,
                                      cx: point.x,
                                      cy: point.y,
                                      r: "4",
                                      class: "latency-point"
                                    }, null, 8 /* PROPS */, _hoisted_48))
                                  }), 128 /* KEYED_FRAGMENT */))
                                ])),
                                _createElementVNode("div", _hoisted_49, [
                                  _createElementVNode("span", null, _toDisplayString(_ctx.latencyChart.firstLabel), 1 /* TEXT */),
                                  _createElementVNode("span", null, _toDisplayString(_ctx.latencyChart.middleLabel), 1 /* TEXT */),
                                  _createElementVNode("span", null, _toDisplayString(_ctx.latencyChart.lastLabel), 1 /* TEXT */)
                                ])
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_50, "No execution timing data is available yet. "))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_51, [
                        (_ctx.courierPerformance.length)
                          ? (_openBlock(), _createElementBlock("section", _hoisted_52, [
                              _cache[13] || (_cache[13] = _createElementVNode("div", { class: "meta-card-header shipment-modal-card-header" }, [
                                _createElementVNode("h4", null, "Courier snapshot"),
                                _createElementVNode("p", null, "Aggregated over the selected range.")
                              ], -1 /* CACHED */)),
                              _createElementVNode("div", _hoisted_53, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courierPerformance, (courier) => {
                                  return (_openBlock(), _createElementBlock("article", {
                                    key: courier.name,
                                    class: "courier-card"
                                  }, [
                                    _createElementVNode("div", _hoisted_54, [
                                      _createElementVNode("strong", null, _toDisplayString(courier.name), 1 /* TEXT */),
                                      _createElementVNode("span", null, _toDisplayString(_ctx.formatPercent(courier.success_rate)), 1 /* TEXT */)
                                    ]),
                                    _createElementVNode("div", _hoisted_55, [
                                      _createElementVNode("span", null, _toDisplayString(courier.processed) + " processed", 1 /* TEXT */),
                                      _createElementVNode("span", null, _toDisplayString(courier.failed) + " failed", 1 /* TEXT */),
                                      _createElementVNode("span", null, _toDisplayString(courier.avg_response_time_ms ? _ctx.formatDuration(courier.avg_response_time_ms) :
                          'No latency data'), 1 /* TEXT */)
                                    ])
                                  ]))
                                }), 128 /* KEYED_FRAGMENT */))
                              ])
                            ]))
                          : _createCommentVNode("v-if", true),
                        (_ctx.commonErrors.length)
                          ? (_openBlock(), _createElementBlock("section", _hoisted_56, [
                              _cache[14] || (_cache[14] = _createElementVNode("div", { class: "meta-card-header shipment-modal-card-header" }, [
                                _createElementVNode("h4", null, "Common errors"),
                                _createElementVNode("p", null, "Most frequent failure signatures in this range.")
                              ], -1 /* CACHED */)),
                              _createElementVNode("div", _hoisted_57, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.commonErrors, (error) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: error.error,
                                    class: "common-error-item"
                                  }, [
                                    _createElementVNode("div", null, [
                                      _createElementVNode("strong", null, _toDisplayString(error.error), 1 /* TEXT */),
                                      _createElementVNode("span", null, _toDisplayString(error.count) + " occurrence" + _toDisplayString(error.count === 1 ? '' : 's'), 1 /* TEXT */)
                                    ]),
                                    _createElementVNode("span", _hoisted_58, _toDisplayString(_ctx.formatPercent(error.percentage)), 1 /* TEXT */)
                                  ]))
                                }), 128 /* KEYED_FRAGMENT */))
                              ])
                            ]))
                          : _createCommentVNode("v-if", true)
                      ]),
                      _createElementVNode("section", _hoisted_59, [
                        _cache[16] || (_cache[16] = _createElementVNode("div", { class: "meta-card-header shipment-modal-card-header" }, [
                          _createElementVNode("h4", null, "Recent errors"),
                          _createElementVNode("p", null, "Latest shipment tracking failures from recent executions.")
                        ], -1 /* CACHED */)),
                        (_ctx.recentErrors.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                              _createElementVNode("table", _hoisted_61, [
                                _cache[15] || (_cache[15] = _createElementVNode("thead", null, [
                                  _createElementVNode("tr", null, [
                                    _createElementVNode("th", null, "Time"),
                                    _createElementVNode("th", null, "Courier"),
                                    _createElementVNode("th", null, "Tracking"),
                                    _createElementVNode("th", null, "Error")
                                  ])
                                ], -1 /* CACHED */)),
                                _createElementVNode("tbody", null, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recentErrors, (error) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                      key: error.key
                                    }, [
                                      _createElementVNode("td", null, _toDisplayString(error.timeLabel), 1 /* TEXT */),
                                      _createElementVNode("td", null, [
                                        _createElementVNode("span", _hoisted_62, _toDisplayString(error.courier), 1 /* TEXT */)
                                      ]),
                                      _createElementVNode("td", _hoisted_63, _toDisplayString(error.tracking_no), 1 /* TEXT */),
                                      _createElementVNode("td", null, _toDisplayString(error.error), 1 /* TEXT */)
                                    ]))
                                  }), 128 /* KEYED_FRAGMENT */))
                                ])
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_64, "No recent tracking errors were found."))
                      ])
                    ], 64 /* STABLE_FRAGMENT */))
              ])
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ]))
  ]))
}